import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  clickStreamUser,
  isEllipses,
  truncateText,
  SessionKeys,
  forYouOnSuccessBookMark,
  continueYouJourneyApi,
  fetchNonMyOBLPList,
} from "../../../utils/AppUtils";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { saveBookmark } from "../../../redux/courses/actions";
import CONFIG from "../../../utils/config";
import API_LIST from "../../../utils/apiList";
import { setIsLoadingGlobal } from "../../../redux/home/actions";

const ProductCardFinwell = (props) => {
  const {
    id,
    productType,
    productOrigin,
    dbId,
    is_like,
    is_bookmark,
    title,
    logoAltText,
    logoURL,
    bannerURL,
    tagsArray,
    descAction,
    description,
    btnTitle,
    btnAction,
    bannerAction,
    footerLineComp,
    showHeader,
    showBody,
    showFooter,
    leftBtnIcon,
    rightBtnIcon,
    cardClassName,
    isLoading,
    progress,
    ratings,
    duration,
    showProgress,
    showPlayButton,
    showProviderIcon,
    lastKey,
    refInfo,
    showLikeMenu,
    showContentMenu,
    updatedAt,
    isCol12,
    priceInfo,
    isBundle,
    bundles,
    show4,
    ecom_id,
    is_wishlist,
    showSubmitAndReview,
    showSubmittedBy,
    submittedBy,
    submittedOn,
    showReviewedBy,
    reviewedBy,
    feedbackStatus,
    reviewedOn,
    fromWishList,
    isCart,
    is_coaching,
    show_subscription,
    isLock,
    tooltip,
    is_checklist_approved,
    checklist_approved_by,
    is_checklist_present,
    is_learn_more,
    setShowCL,
    setCheckListLp,
    clInfo,
    showRating,
    skills,
    skillsAsString,
    showIndustry,
    industry,
    showExperience,
    experience,
    status,
    asset_type,
    showThumbnail,
    isCalculator,
    isCoachPick,
    isFeatured,
    cate,
    monitoring_name,
    asset_icon,
    monitoring_icon,
    fromPage,
    shareClicked,
    componentKey,
  } = props;

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const authBroker = useSelector((state) => state.auth.authBroker);
  const [isBookmarked, setIsBookmarked] = useState(is_bookmark);
  const isLoadingGlobal = useSelector((state) => state.home.isLoadingGlobal);
  const [isBookmarkLoading, setIsBookmarkLoading] = useState(false);
  const [showShareBadge, setShowShareBadge] = useState(false);
  const [isShareLoading, setIsShareLoading] = useState(false);

  useEffect(() => {
    console.log("btnAction", id);
  }, [btnAction, id]);

  const handleShareClick = (e) => {
    e.stopPropagation();
    setIsShareLoading(true);
    if (componentKey) {
      sessionStorage.setItem("shareComponentKey", componentKey);
    }
    if (shareClicked) shareClicked();
  };

  useEffect(() => {
    setIsBookmarked(is_bookmark);
  }, [is_bookmark]);

  useEffect(() => {
    setIsShareLoading(isLoadingGlobal);
  }, [isLoadingGlobal]);

  useEffect(() => {
    const handleUrlCopied = (e) => {
      console.log(
        "urlCopied event - Card componentKey:",
        componentKey,
        "Event componentKey:",
        e.detail?.componentKey,
      );
      if (e.detail?.componentKey === componentKey) {
        console.log("Showing badge for card:", componentKey);
        setShowShareBadge(true);
        setIsShareLoading(false);
        setTimeout(() => {
          setShowShareBadge(false);
        }, 2000);
      }
    };

    window.addEventListener("urlCopied", handleUrlCopied);
    return () => {
      window.removeEventListener("urlCopied", handleUrlCopied);
    };
  }, [componentKey]);

  const handleBookmarkClick = async (e) => {
    e.stopPropagation();

    if (isBookmarkLoading) return;

    const newBookmarkState = !isBookmarked;

    try {
      setIsBookmarkLoading(true);

      const payload = {
        entity_id: dbId,
        entity_type: productType || "course",
        action: newBookmarkState ? "add" : "remove",
        token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
      };
      dispatch(setIsLoadingGlobal(true));
      const response = await fetch(
        CONFIG.API_URL_BROKER_ADMIN + "/wp-json/xsel/v2/save-bookmarks",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      if (response.ok) {
        setIsBookmarked(newBookmarkState);

        if (fromPage !== "explore") {
          continueYouJourneyApi(dispatch, authBroker);
          forYouOnSuccessBookMark(dispatch);
          fetchNonMyOBLPList(dispatch, authBroker);
        }
      }
    } catch (error) {
      console.error("Bookmark save failed:", error);
    } finally {
      setIsBookmarkLoading(false);
      if (fromPage === "explore") {
        dispatch(setIsLoadingGlobal(false));
      }
    }
  };
  return (
    <>
      <div className="course-box">
        <div
          className="card-money cursor-pointer"
          tabIndex="0"
          aria-label="Take the tour. Learn where everything is so you can start digging into the content."
          onClick={() => {
            clickStreamUser(
              "banner_clicked",
              {
                userId: authBroker?.payload?.user?.user_id,
                id: id,
                title: title,
              },
              authBroker,
            );
            bannerAction();
          }}
        >
          <div className="upper-section-course position-relative">
            {showThumbnail !== "0" && (
              <div className="img-box-info cursor-pointer">
                <img
                  src={bannerURL ? bannerURL : "/images/finwell-img/image2.png"}
                  alt="Finwell 1"
                  className="img-fluid"
                />
                {isFeatured && (
                  <div
                    style={{
                      backgroundColor: "#ff6900",
                      bottom: "8px",
                      left: "8px",
                      position: "absolute",
                      padding: "6px 12px",
                      borderRadius: "20px",
                      color: "white",
                      fontSize: "14px",
                      lineHeight: "16px",
                    }}
                  >
                    <span className="d-flex align-items-center justify-content-center">
                      {t("Featured")}
                    </span>
                  </div>
                )}
                {isCoachPick && (
                  <div className="couch-cls">
                    <span>{t("Coach Pick")}</span>
                  </div>
                )}
                <div className="banner-actions">
                  <div
                    className="share-btn-wrapper"
                    title={showShareBadge ? "Url Copied" : ""}
                    style={{ position: "relative" }}
                  >
                    {!showShareBadge && !isShareLoading && (
                      <button
                        className="action-btn share-btn"
                        aria-label="Share"
                        onClick={(e) => handleShareClick(e)}
                        title={`Get link for ${title}`}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.5"
                        >
                          <circle cx="18" cy="5" r="3" />
                          <circle cx="6" cy="12" r="3" />
                          <circle cx="18" cy="19" r="3" />
                          <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
                          <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
                        </svg>
                      </button>
                    )}

                    {isShareLoading && (
                      <button
                        className="action-btn share-btn"
                        disabled
                        aria-label="Loading"
                      >
                        <svg
                          className="spinner"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                        >
                          <circle cx="12" cy="12" r="10" opacity="0.25" />
                          <path
                            d="M12 2a10 10 0 0 1 10 10"
                            strokeDasharray="15.7"
                          />
                        </svg>
                      </button>
                    )}

                    {showShareBadge && !isShareLoading && (
                      <div className="share-link-badge" title={`URL Copied!`}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                        <span>Link Copied</span>
                      </div>
                    )}
                  </div>
                  <button
                    className={`action-btn bookmark-btn ${isBookmarked ? "active" : ""}`}
                    aria-label="Bookmark"
                    title={isBookmarked ? "Remove Bookmark" : "Bookmark"}
                    onClick={handleBookmarkClick}
                  >
                    {isBookmarkLoading ? (
                      <svg
                        className="spinner"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                      >
                        <circle cx="12" cy="12" r="10" opacity="0.25" />
                        <path
                          d="M12 2a10 10 0 0 1 10 10"
                          strokeDasharray="15.7"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill={isBookmarked ? "currentColor" : "none"}
                        stroke="currentColor"
                        strokeWidth="1.5"
                      >
                        <path d="M17 3a2 2 0 0 1 2 2v15a1 1 0 0 1-1.496.868l-4.512-2.578a2 2 0 0 0-1.984 0l-4.512 2.578A1 1 0 0 1 5 20V5a2 2 0 0 1 2-2z"></path>
                      </svg>
                    )}
                  </button>
                </div>
              </div>
            )}
            {showThumbnail === "0" && false && (
              <div
                className="banner-actions assess-banner-actions"
                style={{
                  position: "absolute",
                  top: "0.75rem",
                  right: "0.75rem",
                }}
              >
                <div
                  className="share-btn-wrapper"
                  title={showShareBadge ? "Url Copied" : ""}
                  style={{ position: "relative" }}
                >
                  {!showShareBadge && !isShareLoading && (
                    <button
                      className="action-btn share-btn"
                      aria-label="Share"
                      onClick={(e) => handleShareClick(e)}
                      title={`Get link for ${title}`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.5"
                      >
                        <circle cx="18" cy="5" r="3" />
                        <circle cx="6" cy="12" r="3" />
                        <circle cx="18" cy="19" r="3" />
                        <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
                        <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
                      </svg>
                    </button>
                  )}

                  {isShareLoading && (
                    <button
                      className="action-btn share-btn"
                      disabled
                      aria-label="Loading"
                    >
                      <svg
                        className="spinner"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                      >
                        <circle cx="12" cy="12" r="10" opacity="0.25" />
                        <path
                          d="M12 2a10 10 0 0 1 10 10"
                          strokeDasharray="15.7"
                        />
                      </svg>
                    </button>
                  )}

                  {showShareBadge && !isShareLoading && (
                    <div className="share-link-badge" title={`URL Copied!`}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                      <span>Link Copied</span>
                    </div>
                  )}
                </div>
                <button
                  className={`action-btn bookmark-btn ${isBookmarked ? "active" : ""}`}
                  aria-label="Bookmark"
                  title={isBookmarked ? "Remove Bookmark" : "Bookmark"}
                  onClick={handleBookmarkClick}
                >
                  {isBookmarkLoading ? (
                    <svg
                      className="spinner"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                    >
                      <circle cx="12" cy="12" r="10" opacity="0.25" />
                      <path
                        d="M12 2a10 10 0 0 1 10 10"
                        strokeDasharray="15.7"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill={isBookmarked ? "currentColor" : "none"}
                      stroke="currentColor"
                      strokeWidth="1.5"
                    >
                      <path d="M17 3a2 2 0 0 1 2 2v15a1 1 0 0 1-1.496.868l-4.512-2.578a2 2 0 0 0-1.984 0l-4.512 2.578A1 1 0 0 1 5 20V5a2 2 0 0 1 2-2z"></path>
                    </svg>
                  )}
                </button>
              </div>
            )}
            <div className="content-box">
              {showThumbnail === "0" ? (
                <div className="d-flex justify-content-between align-items-start w-100">
                  <h3 className="card-money-title cursor-pointer">
                    {isCalculator && isCoachPick && (
                      <span className="couch-cls position-relative botto-0 left-0">
                        <span>{t("Coach Pick")}</span>
                      </span>
                    )}
                    <span
                      title={title}
                      dangerouslySetInnerHTML={{
                        __html: title,
                      }}
                    ></span>
                  </h3>
                  <div
                    className="banner-actions assess-banner-actions"
                    style={{
                      position: "relative",
                      top: "0",
                      right: "0",
                    }}
                  >
                    <div
                      className="share-btn-wrapper"
                      title={showShareBadge ? "Url Copied" : ""}
                      style={{ position: "relative" }}
                    >
                      {!showShareBadge && !isShareLoading && (
                        <button
                          className="action-btn share-btn"
                          aria-label="Share"
                          onClick={(e) => handleShareClick(e)}
                          title={`Get link for ${title}`}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.5"
                          >
                            <circle cx="18" cy="5" r="3" />
                            <circle cx="6" cy="12" r="3" />
                            <circle cx="18" cy="19" r="3" />
                            <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
                            <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
                          </svg>
                        </button>
                      )}

                      {isShareLoading && (
                        <button
                          className="action-btn share-btn"
                          disabled
                          aria-label="Loading"
                        >
                          <svg
                            className="spinner"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                          >
                            <circle cx="12" cy="12" r="10" opacity="0.25" />
                            <path
                              d="M12 2a10 10 0 0 1 10 10"
                              strokeDasharray="15.7"
                            />
                          </svg>
                        </button>
                      )}

                      {showShareBadge && !isShareLoading && (
                        <div className="share-link-badge" title={`URL Copied!`}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <polyline points="20 6 9 17 4 12"></polyline>
                          </svg>
                          <span>Link Copied</span>
                        </div>
                      )}
                    </div>
                    <button
                      className={`action-btn bookmark-btn ${isBookmarked ? "active" : ""}`}
                      aria-label="Bookmark"
                      title={isBookmarked ? "Remove Bookmark" : "Bookmark"}
                      onClick={handleBookmarkClick}
                    >
                      {isBookmarkLoading ? (
                        <svg
                          className="spinner"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                        >
                          <circle cx="12" cy="12" r="10" opacity="0.25" />
                          <path
                            d="M12 2a10 10 0 0 1 10 10"
                            strokeDasharray="15.7"
                          />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill={isBookmarked ? "currentColor" : "none"}
                          stroke="currentColor"
                          strokeWidth="1.5"
                        >
                          <path d="M17 3a2 2 0 0 1 2 2v15a1 1 0 0 1-1.496.868l-4.512-2.578a2 2 0 0 0-1.984 0l-4.512 2.578A1 1 0 0 1 5 20V5a2 2 0 0 1 2-2z"></path>
                        </svg>
                      )}
                    </button>
                  </div>
                </div>
              ) : (
                ""
              )}
              {showThumbnail !== "0" ? (
                <h3 className="card-money-title cursor-pointer">
                  {isCalculator && isCoachPick && (
                    <span className="couch-cls position-relative botto-0 left-0">
                      <span>{t("Coach Pick")}</span>
                    </span>
                  )}
                  <span
                    title={title}
                    dangerouslySetInnerHTML={{
                      __html: title,
                    }}
                  ></span>
                </h3>
              ) : (
                ""
              )}
              <div
                title={description}
                className="disc-content"
                dangerouslySetInnerHTML={{
                  __html: description,
                }}
              ></div>
            </div>
          </div>
          <div className="lower-section-course mt-3">
            {isCalculator ? (
              <div className="linkiconfooter d-flex gap-3 align-items">
                <OverlayTrigger
                  placement="top"
                  delay={{
                    show: 250,
                    hide: 400,
                  }}
                  overlay={
                    <Tooltip id="tooltip-disabled">
                      <strong>{t("Content Type")}</strong>
                    </Tooltip>
                  }
                >
                  <span class="ionc-info align-items-center gap-1">
                    {asset_icon ? (
                      <img
                        src={asset_icon}
                        width="14"
                        height="16"
                        alt="icon"
                        className="icon-cardbox img-fluid"
                      ></img>
                    ) : (
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16 0.0239258V13.6559C16 13.8586 15.9413 14.0453 15.824 14.2159C15.7067 14.3866 15.552 14.5093 15.36 14.5839C13.0453 15.4906 10.6187 15.9546 8.08 15.9759C5.56267 15.9653 3.09333 15.5066 0.672 14.5999C0.490667 14.5359 0.336 14.4239 0.208 14.2639C0.0906667 14.1146 0.0213333 13.9439 0 13.7519V0.0239258H16ZM15.008 1.01593H0.992V13.6559C3.31733 14.5306 5.68 14.9733 8.08 14.9839C10.32 14.9626 12.496 14.5679 14.608 13.7999L15.008 13.6559V1.01593ZM9.664 11.5599C9.84533 11.5599 10 11.6239 10.128 11.7519C10.2667 11.8799 10.336 12.0346 10.336 12.2159C10.336 12.3973 10.2667 12.5573 10.128 12.6959C10 12.8239 9.84533 12.8879 9.664 12.8879C9.48267 12.8879 9.328 12.8239 9.2 12.6959C9.072 12.5573 9.008 12.3973 9.008 12.2159C9.008 12.0346 9.072 11.8799 9.2 11.7519C9.328 11.6239 9.48267 11.5599 9.664 11.5599ZM3.008 11.5599C3.18933 11.5599 3.344 11.6239 3.472 11.7519C3.6 11.8799 3.664 12.0346 3.664 12.2159C3.664 12.3973 3.6 12.5573 3.472 12.6959C3.344 12.8239 3.18933 12.8879 3.008 12.8879C2.82667 12.8879 2.66667 12.8239 2.528 12.6959C2.4 12.5573 2.336 12.3973 2.336 12.2159C2.336 12.0346 2.4 11.8799 2.528 11.7519C2.66667 11.6239 2.82667 11.5599 3.008 11.5599ZM6.336 11.5599C6.51733 11.5599 6.672 11.6239 6.8 11.7519C6.93867 11.8799 7.008 12.0346 7.008 12.2159C7.008 12.3973 6.93867 12.5573 6.8 12.6959C6.672 12.8239 6.51733 12.8879 6.336 12.8879C6.15467 12.8879 5.99467 12.8239 5.856 12.6959C5.728 12.5573 5.664 12.3973 5.664 12.2159C5.664 12.0346 5.728 11.8799 5.856 11.7519C5.99467 11.6239 6.15467 11.5599 6.336 11.5599ZM13.008 11.5599C13.1893 11.5599 13.344 11.6239 13.472 11.7519C13.6 11.8799 13.664 12.0346 13.664 12.2159C13.664 12.3973 13.6 12.5573 13.472 12.6959C13.344 12.8239 13.1893 12.8879 13.008 12.8879C12.8267 12.8879 12.6667 12.8239 12.528 12.6959C12.4 12.5573 12.336 12.3973 12.336 12.2159C12.336 12.0346 12.4 11.8799 12.528 11.7519C12.6667 11.6239 12.8267 11.5599 13.008 11.5599ZM9.664 8.43993C9.84533 8.43993 10 8.50926 10.128 8.64793C10.2667 8.77593 10.336 8.93059 10.336 9.11193C10.336 9.29326 10.2667 9.44793 10.128 9.57593C10 9.70393 9.84533 9.76793 9.664 9.76793C9.48267 9.76793 9.328 9.70393 9.2 9.57593C9.072 9.44793 9.008 9.29326 9.008 9.11193C9.008 8.93059 9.072 8.77593 9.2 8.64793C9.328 8.50926 9.48267 8.43993 9.664 8.43993ZM3.008 8.43993C3.18933 8.43993 3.344 8.50926 3.472 8.64793C3.6 8.77593 3.664 8.93059 3.664 9.11193C3.664 9.29326 3.6 9.44793 3.472 9.57593C3.344 9.70393 3.18933 9.76793 3.008 9.76793C2.82667 9.76793 2.66667 9.70393 2.528 9.57593C2.4 9.44793 2.336 9.29326 2.336 9.11193C2.336 8.93059 2.4 8.77593 2.528 8.64793C2.66667 8.50926 2.82667 8.43993 3.008 8.43993ZM6.336 8.43993C6.51733 8.43993 6.672 8.50926 6.8 8.64793C6.93867 8.77593 7.008 8.93059 7.008 9.11193C7.008 9.29326 6.93867 9.44793 6.8 9.57593C6.672 9.70393 6.51733 9.76793 6.336 9.76793C6.15467 9.76793 5.99467 9.70393 5.856 9.57593C5.728 9.44793 5.664 9.29326 5.664 9.11193C5.664 8.93059 5.728 8.77593 5.856 8.64793C5.99467 8.50926 6.15467 8.43993 6.336 8.43993ZM13.008 8.43993C13.1893 8.43993 13.344 8.50926 13.472 8.64793C13.6 8.77593 13.664 8.93059 13.664 9.11193C13.664 9.29326 13.6 9.44793 13.472 9.57593C13.344 9.70393 13.1893 9.76793 13.008 9.76793C12.8267 9.76793 12.6667 9.70393 12.528 9.57593C12.4 9.44793 12.336 9.29326 12.336 9.11193C12.336 8.93059 12.4 8.77593 12.528 8.64793C12.6667 8.50926 12.8267 8.43993 13.008 8.43993ZM13.504 1.92793V6.15193H2.4V1.92793H13.504ZM12.496 2.93593H3.408V5.15993H12.496V2.93593Z"
                          fill="#474747"
                        />
                      </svg>
                    )}{" "}
                    <span className="text-sd">{t("Calculator")}</span>
                  </span>
                </OverlayTrigger>
                {monitoring_name && (
                  <OverlayTrigger
                    placement="top"
                    delay={{
                      show: 250,
                      hide: 400,
                    }}
                    overlay={
                      <Tooltip id="tooltip-disabled">
                        <div>
                          <strong>{t("Monitoring Ring")}</strong>
                        </div>
                        {isEllipses(monitoring_name) ? (
                          <span
                            className="text-sd"
                            dangerouslySetInnerHTML={{
                              __html: monitoring_name,
                            }}
                          ></span>
                        ) : (
                          ""
                        )}
                      </Tooltip>
                    }
                  >
                    <span class="ionc-info align-items-center gap-1">
                      {monitoring_icon ? (
                        <img
                          src={monitoring_icon}
                          width="14"
                          height="16"
                          alt="icon"
                          className="icon-cardbox img-fluid"
                        ></img>
                      ) : (
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.18406 8.16L9.36806 12.944L9.73606 12.56L10.4561 11.856L13.1601 14.576L14.5841 13.152L12.5681 11.152L11.8641 10.432L12.9521 9.344L8.18406 8.16ZM6.80806 6.784L14.9041 8.8L13.2881 10.432L15.9921 13.152L13.1601 16L10.4561 13.28L8.80806 14.912L6.80806 6.784ZM7.14406 12.352L7.40006 13.344H7.35206C7.06406 13.3653 6.84539 13.376 6.69606 13.376C5.48006 13.376 4.35472 13.072 3.32006 12.464C2.30672 11.8773 1.50672 11.0773 0.920057 10.064C0.312057 9.02933 0.00805664 7.90933 0.00805664 6.704C0.00805664 5.488 0.312057 4.36267 0.920057 3.328C1.50672 2.31467 2.30139 1.51467 3.30406 0.927999C4.33872 0.309333 5.46406 0 6.68006 0C7.89606 0 9.02139 0.298667 10.0561 0.896C11.0694 1.48267 11.8694 2.28267 12.4561 3.296C13.0747 4.33067 13.3841 5.45067 13.3841 6.656C13.3841 6.816 13.3734 7.056 13.3521 7.376L12.3761 7.136C12.3867 7.02933 12.3921 6.86933 12.3921 6.656C12.3921 5.89867 12.2427 5.17333 11.9441 4.48C11.6561 3.776 11.2454 3.15733 10.7121 2.624C10.1787 2.09067 9.56006 1.68 8.85606 1.392C8.15206 1.09333 7.42139 0.944 6.66406 0.944C5.91739 0.944 5.19206 1.088 4.48806 1.376C3.79472 1.664 3.17606 2.08 2.63206 2.624C2.08806 3.168 1.67206 3.792 1.38406 4.496C1.10672 5.18933 0.968057 5.91467 0.968057 6.672C0.968057 7.42933 1.11206 8.16 1.40006 8.864C1.69872 9.568 2.11472 10.1867 2.64806 10.72C3.19206 11.2427 3.81072 11.648 4.50406 11.936C5.20806 12.224 5.93872 12.368 6.69606 12.368L7.14406 12.352ZM6.60006 10.16L6.85606 11.184H6.69606C5.87472 11.184 5.11739 10.9813 4.42406 10.576C3.74139 10.1707 3.19739 9.62667 2.79206 8.944C2.38672 8.25067 2.18406 7.49867 2.18406 6.688C2.18406 5.86667 2.38672 5.104 2.79206 4.4C3.19739 3.728 3.73606 3.18933 4.40806 2.784C5.11206 2.37867 5.86939 2.176 6.68006 2.176C7.50139 2.176 8.25872 2.37867 8.95206 2.784C9.63472 3.17867 10.1787 3.72267 10.5841 4.416C10.9894 5.09867 11.1921 5.84533 11.1921 6.656V6.832L10.2001 6.592C10.1894 5.96267 10.0187 5.38667 9.68806 4.864C9.36806 4.33067 8.94139 3.91467 8.40806 3.616C7.87472 3.30667 7.29339 3.152 6.66406 3.152C6.03472 3.152 5.45339 3.312 4.92006 3.632C4.38672 3.94133 3.96006 4.36267 3.64006 4.896C3.33072 5.41867 3.17606 5.99467 3.17606 6.624C3.17606 7.25333 3.32539 7.84 3.62406 8.384C3.93339 8.91733 4.34939 9.344 4.87206 9.664C5.39472 9.984 5.97072 10.1493 6.60006 10.16Z"
                            fill="#474747"
                          />
                        </svg>
                      )}{" "}
                      <span
                        className="text-sd"
                        dangerouslySetInnerHTML={{
                          __html: truncateText(monitoring_name),
                        }}
                      ></span>
                    </span>
                  </OverlayTrigger>
                )}
                {cate && (
                  <OverlayTrigger
                    placement="top"
                    delay={{
                      show: 250,
                      hide: 400,
                    }}
                    overlay={
                      <Tooltip id="tooltip-disabled">
                        <div>
                          <strong>{t("Content Category")}</strong>
                        </div>
                        {isEllipses(cate, 7) ? (
                          <span
                            className="text-sd"
                            dangerouslySetInnerHTML={{
                              __html: cate,
                            }}
                          ></span>
                        ) : (
                          ""
                        )}
                      </Tooltip>
                    }
                  >
                    <span class="ionc-info align-items-center gap-1">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8 0.992188L16 8.99219H13.504V15.0082H2.496V8.99219H0L8 0.992188ZM8 2.49619L2.496 8.00019H3.504V14.0002H12.496V8.00019H13.504L8 2.49619Z"
                          fill="#474747"
                        />
                      </svg>{" "}
                      <span
                        className="text-sd"
                        dangerouslySetInnerHTML={{
                          __html: truncateText(cate, 7),
                        }}
                      ></span>
                    </span>
                  </OverlayTrigger>
                )}
              </div>
            ) : (
              <div class="linkiconfooter d-flex gap-2 align-items">
                <OverlayTrigger
                  placement="top"
                  delay={{
                    show: 250,
                    hide: 400,
                  }}
                  overlay={
                    <Tooltip id="tooltip-disabled">
                      <div>
                        <strong>{t("Duration")}</strong>
                      </div>
                      {isEllipses(duration + "") ? duration : ""}
                    </Tooltip>
                  }
                >
                  <span class="ionc-info align-items-center gap-1">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8 0C9.088 0 10.128 0.208 11.12 0.624C12.0693 1.02933 12.912 1.60533 13.648 2.352C14.3947 3.088 14.9707 3.93067 15.376 4.88C15.792 5.872 16 6.912 16 8C16 9.088 15.792 10.128 15.376 11.12C14.9707 12.0693 14.3947 12.912 13.648 13.648C12.912 14.3947 12.0693 14.9707 11.12 15.376C10.128 15.792 9.088 16 8 16C6.912 16 5.872 15.792 4.88 15.376C3.93067 14.9707 3.08267 14.3947 2.336 13.648C1.6 12.912 1.02933 12.0693 0.624 11.12C0.208 10.128 0 9.088 0 8C0 6.912 0.208 5.872 0.624 4.88C1.02933 3.93067 1.6 3.088 2.336 2.352C3.08267 1.60533 3.93067 1.02933 4.88 0.624C5.872 0.208 6.912 0 8 0ZM8 15.008C9.26933 15.008 10.448 14.688 11.536 14.048C12.592 13.4293 13.4293 12.592 14.048 11.536C14.688 10.448 15.008 9.26933 15.008 8C15.008 6.73067 14.688 5.552 14.048 4.464C13.4293 3.408 12.592 2.57067 11.536 1.952C10.448 1.312 9.26933 0.992 8 0.992C6.74133 0.992 5.568 1.312 4.48 1.952C3.424 2.57067 2.58667 3.408 1.968 4.464C1.328 5.552 1.008 6.73067 1.008 8C1.008 9.26933 1.328 10.448 1.968 11.536C2.58667 12.592 3.424 13.4293 4.48 14.048C5.568 14.688 6.74133 15.008 8 15.008ZM8.496 7.504H12.96V8.496H7.504V3.04H8.496V7.504Z"
                        fill="#474747"
                      />
                    </svg>
                    <span className="text-sd">
                      {truncateText(duration + "")}
                    </span>
                  </span>
                </OverlayTrigger>
                <OverlayTrigger
                  placement="top"
                  delay={{
                    show: 250,
                    hide: 400,
                  }}
                  overlay={
                    <Tooltip id="tooltip-disabled">
                      <div>
                        <strong>{t("Content Type")}</strong>
                      </div>
                      {isEllipses(asset_type) ? asset_type : ""}
                    </Tooltip>
                  }
                >
                  <span class="ionc-info align-items-center gap-1">
                    {asset_icon ? (
                      <img
                        src={asset_icon}
                        width="14"
                        height="16"
                        alt="icon"
                        className="icon-cardbox img-fluid"
                      ></img>
                    ) : (
                      <svg
                        width="14"
                        height="16"
                        viewBox="0 0 14 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.32801 0L13.68 4.864V16H0.320007V0H9.32801ZM8.49601 0.96H1.28001V15.04H12.72V5.44H8.49601V0.96ZM11.488 6.992L11.6 7.12L11.552 7.184V13.104L11.6 13.152L11.488 13.28L8.54401 10.336V12.8H2.56001V7.472H8.54401V9.936L11.488 6.992ZM9.47201 1.36V4.48H12.24L9.47201 1.36Z"
                          fill="#474747"
                        />
                      </svg>
                    )}
                    <span
                      className="text-sd"
                      dangerouslySetInnerHTML={{
                        __html: truncateText(asset_type),
                      }}
                    ></span>
                  </span>
                </OverlayTrigger>
                <OverlayTrigger
                  placement="top"
                  delay={{
                    show: 250,
                    hide: 400,
                  }}
                  overlay={
                    <Tooltip id="tooltip-disabled">
                      <div>
                        <strong>{t("Monitoring Ring")}</strong>
                      </div>
                      {isEllipses(monitoring_name) ? (
                        <span
                          className="text-sd"
                          dangerouslySetInnerHTML={{
                            __html: monitoring_name,
                          }}
                        ></span>
                      ) : (
                        ""
                      )}
                    </Tooltip>
                  }
                >
                  <span class="ionc-info align-items-center gap-1">
                    {monitoring_icon ? (
                      <img
                        src={monitoring_icon}
                        width="14"
                        height="16"
                        alt="icon"
                        className="icon-cardbox img-fluid"
                      ></img>
                    ) : (
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.18406 8.16L9.36806 12.944L9.73606 12.56L10.4561 11.856L13.1601 14.576L14.5841 13.152L12.5681 11.152L11.8641 10.432L12.9521 9.344L8.18406 8.16ZM6.80806 6.784L14.9041 8.8L13.2881 10.432L15.9921 13.152L13.1601 16L10.4561 13.28L8.80806 14.912L6.80806 6.784ZM7.14406 12.352L7.40006 13.344H7.35206C7.06406 13.3653 6.84539 13.376 6.69606 13.376C5.48006 13.376 4.35472 13.072 3.32006 12.464C2.30672 11.8773 1.50672 11.0773 0.920057 10.064C0.312057 9.02933 0.00805664 7.90933 0.00805664 6.704C0.00805664 5.488 0.312057 4.36267 0.920057 3.328C1.50672 2.31467 2.30139 1.51467 3.30406 0.927999C4.33872 0.309333 5.46406 0 6.68006 0C7.89606 0 9.02139 0.298667 10.0561 0.896C11.0694 1.48267 11.8694 2.28267 12.4561 3.296C13.0747 4.33067 13.3841 5.45067 13.3841 6.656C13.3841 6.816 13.3734 7.056 13.3521 7.376L12.3761 7.136C12.3867 7.02933 12.3921 6.86933 12.3921 6.656C12.3921 5.89867 12.2427 5.17333 11.9441 4.48C11.6561 3.776 11.2454 3.15733 10.7121 2.624C10.1787 2.09067 9.56006 1.68 8.85606 1.392C8.15206 1.09333 7.42139 0.944 6.66406 0.944C5.91739 0.944 5.19206 1.088 4.48806 1.376C3.79472 1.664 3.17606 2.08 2.63206 2.624C2.08806 3.168 1.67206 3.792 1.38406 4.496C1.10672 5.18933 0.968057 5.91467 0.968057 6.672C0.968057 7.42933 1.11206 8.16 1.40006 8.864C1.69872 9.568 2.11472 10.1867 2.64806 10.72C3.19206 11.2427 3.81072 11.648 4.50406 11.936C5.20806 12.224 5.93872 12.368 6.69606 12.368L7.14406 12.352ZM6.60006 10.16L6.85606 11.184H6.69606C5.87472 11.184 5.11739 10.9813 4.42406 10.576C3.74139 10.1707 3.19739 9.62667 2.79206 8.944C2.38672 8.25067 2.18406 7.49867 2.18406 6.688C2.18406 5.86667 2.38672 5.104 2.79206 4.4C3.19739 3.728 3.73606 3.18933 4.40806 2.784C5.11206 2.37867 5.86939 2.176 6.68006 2.176C7.50139 2.176 8.25872 2.37867 8.95206 2.784C9.63472 3.17867 10.1787 3.72267 10.5841 4.416C10.9894 5.09867 11.1921 5.84533 11.1921 6.656V6.832L10.2001 6.592C10.1894 5.96267 10.0187 5.38667 9.68806 4.864C9.36806 4.33067 8.94139 3.91467 8.40806 3.616C7.87472 3.30667 7.29339 3.152 6.66406 3.152C6.03472 3.152 5.45339 3.312 4.92006 3.632C4.38672 3.94133 3.96006 4.36267 3.64006 4.896C3.33072 5.41867 3.17606 5.99467 3.17606 6.624C3.17606 7.25333 3.32539 7.84 3.62406 8.384C3.93339 8.91733 4.34939 9.344 4.87206 9.664C5.39472 9.984 5.97072 10.1493 6.60006 10.16Z"
                          fill="#474747"
                        />
                      </svg>
                    )}
                    <span
                      className="text-sd"
                      dangerouslySetInnerHTML={{
                        __html: truncateText(monitoring_name),
                      }}
                    ></span>
                  </span>
                </OverlayTrigger>
              </div>
            )}

            {showProgress && (
              <div class="progress-container mt-3">
                <div class="progress-label">{progress}%</div>
                <div class="progress-bar">
                  <div
                    class="progress-fill"
                    style={{ width: progress + "%" }}
                  ></div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductCardFinwell;
